const state = {
  gyroData: { // 陀螺仪数据
    alpha: 0, // 围绕 z 轴的转动角度。例：alpha: 45 => 表示设备绕 z 轴旋转了 45 度
    beta: 0, // 围绕 x 轴的转动角度
    gamma: 0, // 围绕 y 轴的转动角度
  },
};

// getters
const getters = {
  getGyroData(state) {
    return state.gyroData;
  },
};

// actions
const actions = {

};

// mutations
const mutations = {
  setGyroData(state, info) {
    state.gyroData = info;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
